"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.v18Upgrade = exports.v18Downgrade = void 0;
const v18Downgrade = (actRule) => {
    const { ubCode, clientUuid, embUuid, published, id, event, version, parentVersion, meta } = actRule;
    if (actRule.type === 'embeddable') {
        const { variants, trigger, frequency, referrerTargets, urlTargets, cookieTargets, geoTargets, scheduling, integrations, } = actRule.rule;
        return {
            schemaVersion: 17,
            ubCode,
            clientUuid,
            embUuid,
            variants,
            trigger,
            published,
            frequency,
            referrerTargets,
            id,
            integrations,
            event,
            version,
            parentVersion,
            meta,
            urlTargets,
            cookieTargets,
            geoTargets,
            scheduling,
        };
    }
    else {
        throw new Error('Split test rules are not supported in this version');
    }
};
exports.v18Downgrade = v18Downgrade;
const v18Upgrade = (rule) => {
    const { ubCode, clientUuid, embUuid, variants, trigger, published, frequency, referrerTargets, id, event, version, parentVersion, meta, urlTargets, cookieTargets, geoTargets, scheduling, } = rule;
    return {
        schemaVersion: 18,
        ubCode,
        clientUuid,
        embUuid,
        published,
        id,
        event,
        version,
        parentVersion,
        meta,
        type: 'embeddable',
        rule: {
            cookieTargets,
            frequency,
            geoTargets,
            integrations: rule.integrations,
            referrerTargets,
            scheduling,
            trigger,
            urlTargets,
            variants,
        },
    };
};
exports.v18Upgrade = v18Upgrade;
//# sourceMappingURL=v18.js.map